export var hasTokenExpired = function(axiosError) {
    var ref, ref1;
    if (axiosError === undefined) {
        return false;
    }
    return (axiosError === null || axiosError === void 0 ? void 0 : (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status) === 401 || (axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 403;
};
